/** The next version of a published id, which is what makes editing one an update and not a fork. */

/** Bump the patch, or fall back to a first version when the stored one does not parse. */
export function nextPatch(version: string): string {
  const parts = /^(\d+)\.(\d+)\.(\d+)/u.exec(version);
  if (parts === null) return "0.1.0";
  return `${parts[1] ?? "0"}.${parts[2] ?? "0"}.${String(Number(parts[3] ?? "0") + 1)}`;
}

/** An id that names a copy rather than the original, so a fork never claims the published one. */
export function forkedId(activityId: string): string {
  return `${activityId}_fork`;
}
